import { ApiService } from './api.service';
import { Tag } from '@/models/tag';

class TagService extends ApiService {
  constructor() {
    super();
  }

  getTags(headers: any): Promise<Tag[]> {
    return this.getList(Tag, 'tags', {}, headers);
  }
}

export const tagService = new TagService();
